import React, { useState, useEffect, useContext, useRef } from "react";
import "../../css_files/Master/BoilerSeriesMaster.css";
import Table from "../Homepage/Table";
import AddBoilerSeriesMaster from "./AddBoilerSeriesMaster";
import SearchBoilerSeriesMaster from "./SearchBoilerSeriesMaster";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import getCookie from "../../api";
import { triggerscroll } from "../Homepage/Homepage";
import AddMaster from "./AddMaster";
import SearchMaster from "./SearchMaster";
import Pagination from "../Homepage/Pagination";
import axiosInstance from "../../api";

function BoilerSeriesMaster() {
  const [showaddform, setshowaddform] = useState(false);
  const [showsearchform, setshowsearchform] = useState(false);
  const tablehead = ["Id", "Head", "Series Code", "Description"];
  const [tabledata, setTableData] = useState([]);
  const [reload, setReload] = useState(false);
  const [triggerupdate, settriggerupdate] = useState(false);
  const [boilerseriesupdatedata, setboilerseriesupdatedata] = useState(null);
  const [datareload, setdatareload] = useState(0);
  const [loading, setloading] = useState(false);
  const { setExpiredSession, permissionsdata, userData } =
    useContext(triggerscroll);
  const [pagenumber, setpagenumber] = useState(1);
  const [pagecount, setpagecount] = useState(0);
  const [totalcount, setTotalCount] = useState(0);
  const [excelloading, setexcelloading] = useState(false);
  const [search, setSearch] = useState("");
  const [Ids, setIds] = useState([]);
  const [SubIds, setSubIds] = useState([]);
  const [boilerSeriesId, setboilerSeriesId] = useState(null);

  function fetchboilerseriesdata(boilerseriesid) {
    const url = `${process.env.REACT_APP_API_URL}/api/v1/BoilerSeries/GetBoilerSeriesByIdOrheadOrSeriesCode?id=${boilerseriesid}`;
    axiosInstance
      .get(url)
      .then((res) => {
        setboilerseriesupdatedata(res.data.data[0]);
      })
      .catch(console.log);
  }

  useEffect(() => {
    setloading(true);
    const URL = `${process.env.REACT_APP_API_URL}/api/v1/BoilerSeries/${pagenumber}`;
    axiosInstance
      .post(URL, {
        Id: boilerSeriesId || null,
        Search: search,
        Ids,
        SubIds,
      })
      .then((response) => {
        setpagecount(response.data.count);
        setTotalCount(response.data.dataCount);
        setTableData(
          response.data.data.map((x) => [
            x.id,
            x.boiler.head,
            x.seriesCode,
            x.description,
          ])
        );
      })
      .catch(console.log)
      .finally(() => {
        setloading(false);
      });
  }, [reload, pagenumber, Ids.length, SubIds.length]);

  function readPermission() {
    if (userData.role === "Administrator") return true;

    const issatisfied = permissionsdata.some(
      (x) =>
        x.head === "Master" &&
        x.subHead === "Boiler Series" &&
        x.isRead === true
    );
    return issatisfied;
  }

  function writePermission() {
    if (userData.role === "Administrator") return false;

    const issatisfied = permissionsdata.some(
      (x) =>
        x.head === "Master" &&
        x.subHead === "Boiler Series" &&
        x.isWrite === true
    );
    return !issatisfied;
  }

  function updatePermission() {
    if (userData.role === "Administrator") return false;

    const issatisfied = permissionsdata.some(
      (x) =>
        x.head === "Master" &&
        x.subHead === "Boiler Series" &&
        x.isUpdate === true
    );
    return !issatisfied;
  }

  function deletePermission() {
    if (userData.role === "Administrator") return false;

    const issatisfied = permissionsdata.some(
      (x) =>
        x.head === "Master" &&
        x.subHead === "Boiler Series" &&
        x.isDelete === true
    );
    return !issatisfied;
  }

  return (
    <section className="boiler-series-master">
      <h1>Boiler-Series Master</h1>
      <blockquote className="boiler-series-master-forms">
        <AddMaster
          text="Add Boiler-Series Master"
          setshowaddform={setshowaddform}
          settriggerupdate={settriggerupdate}
          setshowsearchform={setshowsearchform}
          permit={writePermission}
        />

        <SearchMaster
          text="Search Boiler-Series Master"
          setshowsearchform={setshowsearchform}
          setshowaddform={setshowaddform}
        />
      </blockquote>
      {showaddform && (
        <AddBoilerSeriesMaster
          setshowaddform={setshowaddform}
          reload={reload}
          setReload={setReload}
          triggerupdate={triggerupdate}
          boilerseriesupdatedata={boilerseriesupdatedata}
          key={`${boilerseriesupdatedata?.id}-${triggerupdate}-${datareload}`}
        />
      )}
      {showsearchform && (
        <SearchBoilerSeriesMaster
          setshowsearchform={setshowsearchform}
          setpagenumber={setpagenumber}
          setIds={setIds}
          setSubIds={setSubIds}
          setBoilerSeriesId={setboilerSeriesId}
          setReload={setReload}
          setSearch={setSearch}
          reload={reload}
        />
      )}

      <Table
        tablehead={tablehead}
        tabledata={tabledata}
        setshowaddform={setshowaddform}
        settriggerupdate={settriggerupdate}
        fetchdata={fetchboilerseriesdata}
        url="BoilerSeries/UpdateBoilerSeries"
        reload={reload}
        setReload={setReload}
        setdatareload={setdatareload}
        datareload={datareload}
        loading={loading}
        readPermission={readPermission}
        updatePermission={updatePermission}
        deletePermission={deletePermission}
        totalcount={totalcount}
      />
      <Pagination
        count={pagecount}
        setpagenumber={setpagenumber}
        pagenumber={pagenumber}
      />
    </section>
  );
}

export default BoilerSeriesMaster;
